/**
 * Labstep
 *
 * @module screens/Master/Index
 * @desc Index screen
 */

import { LayoutMainContentCenter } from 'labstep-web/components/Layout/MainContent/Center';
import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { MasterIndexCenterMobileContainer as Center } from 'labstep-web/screens/Master/Index/Center';
import { MasterIndexLeftPane as LeftPane } from 'labstep-web/screens/Master/Index/LeftPane';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import styles from './styles.module.scss';
import type { IMasterIndexProps } from './types';

export const MasterIndex: React.FC<IMasterIndexProps> = ({
  leftPane,
  isTemplate,
  ...rest
}) => (
  <>
    <DocumentHead
      title={getHumanReadableEntityName(
        rest.entityName,
        true,
        true,
        isTemplate,
      )}
    />
    <LayoutMainContentCenter>
      <div className={styles.container}>
        {leftPane && <LeftPane leftPane={leftPane} />}
        <Center {...rest} />
      </div>
    </LayoutMainContentCenter>
  </>
);
